import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { AppConstants } from 'src/app/config.service';
import { finalize } from 'rxjs/operators';
import { ExceptionHandlingService } from 'src/app/shared/exception-handling.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService, IMyOptions } from 'ng-uikit-pro-standard';
import { GlobalConstants } from 'src/app/global-constants';
@Component({
  selector: 'edit-document-tags-modal',
  templateUrl: './edit-document-tags-modal.component.html'
})

export class EditDocumentTagsComponent implements OnInit {

  @Input() selections: any;
  @Output() emitSuccess = new EventEmitter<any>();
  error: any = {}

  constructor(
    private service: SharedService,
    private appConstants: AppConstants,
    private errorService: ExceptionHandlingService,
    private toastr: ToastService,
    private translate: TranslateService
  ) { }

  userInfo: any = {}
  ngOnInit() {
    const user = this.appConstants.userDetails
    this.userInfo = user;
  }

  datePickerOptions: IMyOptions = {
    dateFormat: 'mmm-dd-yyyy',
    closeAfterSelect: true,
    editableDateField: false
  };

  modifiedTags: any = [];
  @ViewChild('editDocumentModal', { static: true }) editDocumentModal: any;
  action: any = {}
  ngOnChanges() {
    if (this.selections && this.selections.doc && this.selections.selection) {
      this.tags = [];
      this.editDocumentModal.show();
      this.getAllTags()
    }
  }

  saveModifiedDocument(doc) {
    this.saveTags(doc).then(res => {
      this.editDocumentModal.hide();
      this.emitSuccess.emit(true)
    });
  }

  getDocuments(selection) {
    selection.isLoading = true;
    const _url = this.appConstants.endPoints.sprigEndPoint + 'documents/' + GlobalConstants.scheduleApplicationID + '/documents'
    this.service.get(_url, {
      aboutPath: selection.aboutPath,
      userName: this.userInfo.email,
      pageSize: 100,
      pageNumber: 1,
      applicationId: GlobalConstants.scheduleApplicationID
    })
      .pipe(finalize(() => {
        selection.isLoading = false;
      }))
      .subscribe(data => {
        selection.documents = data && data.searchResults ? data.searchResults : []
      })
  }

  tags: any = []
  editDocumentTagLoader: boolean = false
  getAllTags() {
    this.tags = [];
    this.editDocumentTagLoader = true
    this.service
      .get(this.appConstants.endPoints.sprigEndPoint + 'admin/' + GlobalConstants.scheduleApplicationID + "/tags", {})
      .pipe(finalize(() => {
        this.editDocumentTagLoader = false;
      })).subscribe(tags => {
        let tagData = tags && tags.searchResults ? tags.searchResults : [];
        this.tags = tagData.map(res => {
          return { id: res.id, name: res.tagName }
        });
      })
  }

  saveTags(doc) {
    this.editDocumentTagLoader = true
    return new Promise((resolve, reject) => {
      if (doc.manualTags) {
        let tags = [];
        doc.manualTags.forEach(tag => {
          tags.push({ id: tag.id })
        });
        this.service.put(this.appConstants.endPoints.sprigEndPoint
          + 'documents/' + GlobalConstants.scheduleApplicationID
          + '/documents/' + doc.id, { userName: this.userInfo.email }, { manualTags: tags })
          .pipe(finalize(() => {
            this.editDocumentTagLoader = false;
          })).subscribe(data => {
            this.toastr.success(this.translate.instant('administration_tagUpdatedSuccessfully_label'));
            resolve(data)
          },
            error => {
              this.errorService.errorHandling(error).then(res => {
                this.error = res;
              });
            })
      }
    });
  }

}